import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable()
export class MaintenanceTypeService {

  path:string = "maintenanceType";

  constructor(private httpClient: HttpClient) { }

  findAll():Observable<any>{
    return this.httpClient.get(environment.baseURL + this.path);
  }

  create(entity:any):Observable<any>{
    return this.httpClient.post(environment.baseURL + this.path,entity);
  }

  edit(entity:any):Observable<any>{
    return this.httpClient.put(environment.baseURL + this.path+'/'+entity.idType,entity);
  }

  remove(entity:any):Observable<any>{
    return this.httpClient.delete(environment.baseURL + this.path+'/'+entity.idType);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/maintenance-type.service.ts